import { AuthenticationMiddleware } from '@/api/middleware/authentication-middleware'
import { LoggingMiddleware } from '@/api/middleware/logging-middleware'
import { onBootstrap } from '@/bootstrap'
import { Injector } from '@/config/dependency-injection'
import { ApiMiddlewareToken } from '@/config/injection-tokens'
import { DelayMiddleware } from '@/api/middleware/delay-middleware'
import { KillUrlsMiddleware } from '@/api/middleware/kill-urls-middleware'

onBootstrap.add(() => {
  Injector.bindLazy(ApiMiddlewareToken, () => {
    return [
      Injector.get(LoggingMiddleware),
      Injector.get(AuthenticationMiddleware),
      Injector.get(DelayMiddleware),
      Injector.get(KillUrlsMiddleware),
    ]
  })

  Injector.bindSingleton(AuthenticationMiddleware)
  Injector.bindSingleton(DelayMiddleware)
  Injector.bindSingleton(KillUrlsMiddleware)
  Injector.bindSingleton(LoggingMiddleware)
})
